import equipmentRouter from '../router/equipment.router';

//默认配置
export default {
    menu: [//菜单
        {
            id: "1",
            name: "首页",
            routeUrl: "/",
            icon: "",
            children: [],
        },
        {
            id: "2",
            name: "软件产品",
            routeUrl: "",
            icon: "",
            children: [
                {
                    id: "2-1",
                    name: "采购溯源系统",
                    routeUrl: "/softwareproducts/purchase",
                    icon: "icon-zu405-17",
                    children: [],
                },
                // {
                //     id: "2-2",
                //     name: "统采统配系统",
                //     routeUrl: "",
                //     icon: "icon-zu405-16",
                //     children: [],
                // },
                {
                    id: "2-3",
                    name: "食堂管理系统",
                    routeUrl: "/softwareproducts/canteen",
                    icon: "icon-zu405-15",
                    children: [],
                },
                {
                    id: "2-4",
                    name: "大数据监管系统",
                    routeUrl: "/softwareproducts/bigdata",
                    icon: "icon-zu405-14",
                    children: [],
                },
                // {
                //     id: "2-5",
                //     name: "宣传系统",
                //     routeUrl: "",
                //     icon: "icon-zu405-13",
                //     children: [],
                // },
                {
                    id: "2-6",
                    name: "培训系统",
                    routeUrl: "/softwareproducts/train",
                    icon: "icon-zu405-12",
                    children: [],
                },
            ],
        },
        {
            id: "3",
            name: "智能硬件",
            routeUrl: "",
            icon: "",
            children: [
                // ...equipmentRouter,
                // 电子智能秤
                {
                    id: "3-1",
                    name: '电子智能秤',
                    routeUrl: '/equipment/dzc',
                    icon: "icon-zu405-06",
                    children: [],
                },
                {
                    id: "3-2",
                    name: "晨检仪",
                    routeUrl: "/equipment/cjy",
                    icon: "icon-zu405-07",
                    children: [],
                },
                {
                    id: "3-3",
                    name: "AI视觉分析",
                    routeUrl: "/equipment/sjfx",
                    icon: "icon-zu405-08",
                    children: [],
                },
                {
                    id: "3-4",
                    name: "智能留样柜",
                    routeUrl: "/equipment/znlyg",
                    icon: "icon-zu405-09",
                    children: [],
                },
                {
                    id: "3-5",
                    name: "农产快检仪",
                    routeUrl: "/equipment/nckjy",
                    icon: "icon-zu405-10",
                    children: [],
                },
                {
                    id: "3-6",
                    name: "信息公示屏",
                    routeUrl: "/equipment/xxgsp",
                    icon: "icon-zu405-11",
                    children: [],
                },
			],
        },
        {
            id: "4",
            name: "解决方案",
            routeUrl: "",
            icon: "",
            children: [
                {
                    id: "6-1",
                    name: "城投企业",
                    routeUrl: "/solution/uci-enterprise",
                    icon: "icon-zu405-20",
                    children: [],
                },
                {
                    id: "6-2",
                    name: "教育局/市监局",
                    routeUrl: "/solution/e-ms-bureau",
                    icon: "icon-zu405-18",
                    children: [],
                },
            ],
        },
        {
            id: "5",
            name: "华略学院",
            routeUrl: "",
            icon: "",
            children: [
                {
                    id: "5-0",
                    name: "在线学习平台",
                    Url: "/train",
                    icon: "icon-zu405-05",
                    children: [],
                },
                // {
                //     id: "5-1",
                //     name: "行业资讯",
                //     routeUrl: "/news/industry",
                //     icon: "icon-zu405-05",
                //     children: [],
                // },
                // {
                //     id: "5-2",
                //     name: "公司新闻",
                //     routeUrl: "/news/company",
                //     icon: "icon-zu405-04",
                //     children: [],
                // },
                // {
                //     id: "5-3",
                //     name: "食安知识",
                //     routeUrl: "",
                //     icon: "icon-zu405-03",
                //     children: [],
                // },
            ],
        },
        {
            id: "6",
            name: "关于我们",
            routeUrl: "",
            icon: "",
            children: [
                {
                    id: "6-1",
                    name: "企业介绍",
                    routeUrl: "/about/companies-introduce",
                    icon: "icon-zu405-19",
                    children: [],
                },
                {
                    id: "6-2",
                    name: "行业资讯",
                    routeUrl: "/news/industry",
                    icon: "icon-zu405-05",
                    children: [],
                },
                {
                    id: "6-3",
                    name: "公司新闻",
                    routeUrl: "/news/company",
                    icon: "icon-zu405-04",
                    children: [],
                },
                {
                    id: "6-4",
                    name: "社会责任",
                    routeUrl: "/about/social-responsibility",
                    icon: "icon-zu405-02",
                    children: [],
                },
                {
                    id: "6-5",
                    name: "联系方式",
                    routeUrl: "/about/contact",
                    icon: "icon-zu405-01",
                    children: [],
                },
            ],
        },
    ],

    // 校级
    menuSchool: [//校级菜单
    ],

    //区级
    menuArea: [//区级菜单

    ],
}
